import { WSButton, WSInfoBox, WSText } from "@wingspanhq/fe-component-library";
import type {
  AuditLog,
  AuditLogResource,
  ListAuditLogsFilterParameterResourceTypeEq
} from "@wingspanhq/wingspan-api-sdk";
import lowerCase from "lodash/lowerCase";
import { AttributeChanges } from "./AttributeChanges";

type DrillDownLinkProps = {
  resources?: AuditLogResource[];
  drillDownResourceType?: ListAuditLogsFilterParameterResourceTypeEq;
  onDrillDown?: (resource: AuditLogResource) => void;
};

const DrillDownLink: React.FC<DrillDownLinkProps> = props => {
  if (!props.drillDownResourceType || !props.onDrillDown) return null;

  const resource = props.resources?.find(
    r => r.resourceType === props.drillDownResourceType
  );
  if (!resource) return null;

  return (
    <WSButton.Link size="S" ml="S" onClick={() => props.onDrillDown!(resource)}>
      View {lowerCase(props.drillDownResourceType)} history
    </WSButton.Link>
  );
};

type Props = {
  event: AuditLog;
  drillDownResourceType?: ListAuditLogsFilterParameterResourceTypeEq;
  onDrillDown?: (resource: AuditLogResource) => void;
};

/**
 * A v3 audit-log entry carries a derived `title` plus parseable `changes`. The
 * acting-team-member byline the v1 event feed rendered here has no v3
 * counterpart, so that block is gone. (`note` and `attachmentId` are back on the
 * v3 model but are not surfaced yet.)
 */
export const EventContent: React.FC<Props> = props => (
  <>
    {props.event.title && (
      <WSText.ParagraphSm color="gray600">
        {props.event.title}
        <DrillDownLink
          resources={props.event.resources}
          drillDownResourceType={props.drillDownResourceType}
          onDrillDown={props.onDrillDown}
        />
      </WSText.ParagraphSm>
    )}
    {props.event.changes.length > 0 && (
      <WSInfoBox mt="M">
        <AttributeChanges changes={props.event.changes} />
      </WSInfoBox>
    )}
  </>
);
